import {
  IS_LOGGED_IN,
  SET_TOKEN,
  INVALIDATE_TOKEN
} from '../mutation-types'
import jwtDecode from 'jwt-decode'

// initial state
const token = localStorage.getItem('token')
const state = {
  isLoggedIn: false,
  token: token,
  role: token !== null ? jwtDecode(token).role : null
}

// mutations
const mutations = {
  [SET_TOKEN] (state, token) {
    localStorage.setItem('token', token)
    state.token = token
    state.role = token !== null ? jwtDecode(token).role : null
  },
  [INVALIDATE_TOKEN] (state, token) {
    localStorage.removeItem('token')
    state.isLoggedIn = false
    state.token = null
    state.role = null
  },
  [IS_LOGGED_IN] (state) {
    state.isLoggedIn = true
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/auth/store.js